import React from 'react'
import Layout from '../../Components/Layout/Layout'

const Documents = () => {
  return (
    <Layout>
      
    </Layout>
  )
}

export default Documents
